<template>
  <div class="overflow-absolute">
    <HeroSlider class="hero-slider" />
    <div
      class="container-fluid px-0 justify-content-center align-items-center d-flex page-py"
      :style="{ width: '100vw' , height: isMobile ? winHeight + 'px' : '100vh' }"
    >
      <transition name="text" mode="out-in">
        <div v-show="visible" class="text d-flex align-items-center">
          <h1>
            Make all new
            kinds of amazing
          </h1>
          <h2>
            when you work with
            <span class="talent" @click.prevent="menuToggle()">Toronto talent.</span>
          </h2>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import HeroSlider from '@/components/HeroSlider.vue'

export default {
  name: 'Hero',
  components: {
    HeroSlider
  },
  data() {
    return {
      loading: true,
      isMobile: window.innerWidth <= 420 ? true : false,
      winHeight: window.innerHeight
    }
  },
  computed: {
    searchBool() {
      return this.$store.getters.searchStatus
    },
    visible() {
      return !this.$store.getters.loadingState
    }
  },
  mounted() {
  },

  methods: {
    searchToggle() {
      this.$store.commit('searchStatusChange', this.searchBool)
    },
    menuToggle() {
      this.$store.commit('menuToggle')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hero-slider {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.min-height {
  min-height: 100vh;
}
.text {
  flex-direction: column;
  color: white;
  padding: 20px;
  z-index: 1;
}
h1 {
  font-size: 80px;
  font-family: "Fortescue-light";
  font-weight: normal;
  line-height: 82px;
  max-width: 600px;
  margin: 0;
  text-align: center;
  padding: 20px;
  text-shadow: 3px 3px 10px rgba(0, 0, 0, 0.5);
}
h2 {
  font-size: 37px;
  font-family: "Fortescue-light";
  font-weight: normal;
  text-align: center;
  text-shadow: 3px 3px 10px rgba(0, 0, 0, 0.5);
}
h2 span {
  border-bottom: 1px solid currentColor; /* Or whatever color you want */
  text-decoration: none;
}
.text-leave-active,
.text-enter-active {
  transition: opacity 1.5s;
}

.text-enter,
.text-leave-to {
  opacity: 0;
}

.talent {
  transition: 0.6s;
}
.talent:hover {
  color: #D69A2D;
  cursor: pointer;
}
@media only screen and (max-width: 767.98px) {
  h1 {
    font-size: 40px;
    max-width: 60%;
    padding: 10px;
  }
  h2 {
    font-size: 26px;
    max-width: 70%;
  }
}
@media only screen and (max-width: 576px) {
  h1 {
    line-height: 1.1;
    max-width: 69%;
  }
  .hero-slider {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .text {
    -webkit-overflow-scrolling: auto;
    position: fixed;
  }
}
</style>
